import { FetchError } from './errors/fetch-error';
import { retryOnException } from './retry-operation';
import packageContext from '../utils/package-context';
const extraJsonFromResponse = response => {
  if (response.ok) {
    return response.json();
  }
  throw new FetchError(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
export const fetchJson = (url, init) => fetch(url, {
  credentials: 'include',
  ...init,
  headers: {
    'Atl-App-Switcher-Version': packageContext.packageVersion,
    ...(init === null || init === void 0 ? void 0 : init.headers)
  }
}).then(extraJsonFromResponse);
export const fetchJsonWithNetworkRetries = (url, retryConfig, init) => {
  return retryOnException(() => fetch(url, {
    credentials: 'include',
    ...init,
    headers: {
      'Atl-App-Switcher-Version': packageContext.packageVersion,
      ...(init === null || init === void 0 ? void 0 : init.headers)
    }
  }), retryConfig).then(extraJsonFromResponse);
};
export const postJson = (url, data) => fetchJson(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(data)
});